import ContinueButton from 'js/components/core/SteppedPage/ContinueButton';
import analytics from 'js/services/Analytics';
import { errorResponse, makeRequest, navigate, url } from 'js/services/Network';
import AppState from 'js/stores/AppState';
import { inject, observer } from 'mobx-react';
import React from 'react';
import StepPage from './StepPage';

@inject('page')
@observer
export default class WhatsApp extends React.Component {
  closeModal = () => window.history.back();

  backNav = () =>
    AppUser.isLoggedIn
      ? AppState.previousPage === 'UserDashboardPage'
        ? {
          mode: 'back',
          text: 'Dashboard',
          url: url('user-dashboard-page'),
        }
        : {
          mode: 'back',
          text: 'My items',
          url: url('my-items-page'),
        }
      : { mode: 'normal' };

  saveItemUpload = () => {
    if (AppUser.isLoggedIn) {
      if (this.state.requestInProgress === 0) {
        this.setState({ requestInProgress: 1 })

        makeRequest('create-new-payment-link', null, this.state.catalog)
          .then(response => {
            this.setState({ requestInProgress: 0 })
            const alias = response.data.alias;

            let self = this.page;

            analytics
              .track('Offer Link Created', {
                'Item Price': self.price,
                'Item Name': self.title,
                'Item Quantity': self.quantity || '1',
                'Item Size': self.size,
                'Payment Link': url('checkout-page', { alias }),
                'Location': AppState.currentPage,
                'Event Initiated by': AppState.currentPage === 'CreateNewPaymentLinkPage' || AppState.currentPage === 'SellerLandingPage'
                  ? 'seller' : 'buyer'
              });

            localStorage.setItem('most_recent_item', alias);
            navigate('/create-link/whatsapp', { replace: true })
          })
          .catch(error => {
            this.setState({ requestInProgress: 0 })
            this.props.page.error = errorResponse(error);
          })
      }
    } else {
      this.props.page.setWithSignup(true);
      analytics.page('CTA_SP_create_link_signup');
      AppState.showLoginSignup('signup');
    }
  }

  render() {
    return (
      <StepPage current={2}>
        <h4>Congratulations.</h4>
        <p>
          Yay! you have just added your Item to your checkout. Continue to sign up and get your store link.
        </p>

        <ContinueButton onClick={() => this.saveItemUpload()} disabled={this.state.requestInProgress === 1} flat={false} >Continue</ContinueButton>
      </StepPage>
    );
  }
}
